/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramBouncesControllerHandleBounceMutationResponse,
  TelegramBouncesControllerHandleBounceHeaderParams,
} from '../types/TelegramBouncesControllerHandleBounce.ts';

function getTelegramBouncesHandleBounceUrl() {
  const res = { method: 'POST', url: `/api/telegram/bounces` as const };
  return res;
}

/**
 * {@link /api/telegram/bounces}
 */
export async function telegramBouncesHandleBounce(
  headers: TelegramBouncesControllerHandleBounceHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<TelegramBouncesControllerHandleBounceMutationResponse, ResponseErrorConfig<Error>, unknown>(
    {
      method: 'POST',
      url: getTelegramBouncesHandleBounceUrl().url.toString(),
      ...requestConfig,
      headers: { ...headers, ...requestConfig.headers },
    },
  );
  return res.data;
}
